export const SecretKeys = {
    cryptoSecretKey : "yamaharx100@456"
}